import React from 'react';

class Count extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return(
            <div>
                <h3 class="text-2xl font-bold sm:text-2xl text-center"> {this.props.correctAnswers} / 194</h3>
            </div>
        );
    }
  }
export default Count;